import { LEVEL_ERROR, LEVEL_FATAL } from 'api/LogMessage/logLevel';
import { logMessage as apiLogMessage } from 'api/LogMessage';
import history from 'redux/history';
import sourcemapped from 'sourcemapped-stacktrace';
/**
 * Hold information about a message log
 * For the backend (api/logMessage) call, the
 * message and level get sent as is, but the
 * stack is sent as a string combination of
 * the exact location, the parameters passed,
 * and the sourcemapped stack trace.
 */
class KioskLog {
	/**
	 * Constructor
	 * @param {Error} error
	 * @param {String} stringVar
	 * @param {*} level
	 */
	constructor(error, stringVar, level = LEVEL_ERROR) {
		this.message = `KioskLog - ${error.message}`;
		this.level = level;
		this.stack = error.stack;

		if (!stringVar) {
			this.stringVar = 'No Parameters';
		} else {
			this.stringVar = stringVar;
		}

		// This is for the development only to print to the console.log
		this.location = history.location.pathname;
	}

	/**
	 * sourcemapped has a callback function, so the variables are
	 * getting set here so that they can be properly displayed to the
	 * console and to the backend.
	 *
	 * Method whose behavior depends on the node environment.
	 * If in development mode, the message will be logged in the console.
	 * If not in a test environment, then the message will be
	 * posted to eSTORIS with a 'Kiosk - ' prefix.
	 *
	 * mapStackTrace goes through stack and returns exact locations of errors
	 */
	postMessage() {
		sourcemapped.mapStackTrace(this.stack, async mappedStack => {
			this.stack = mappedStack.join('\n');
			this.origin = this.stack.split('\n');

			this.specific =
				`EXACT LOCATION: ${this.origin[1]} --- ` +
				`PARAMETER INFO: ${this.stringVar} --- ` +
				`STACK: ${this.stack} --- `;
			if (process.env.NODE_ENV === 'development') {
				// eslint-disable-next-line no-console
				console.log(
					this.message,
					'\n\tFile Location:  ',
					this.origin[1],
					'\n\tSource Location:\t',
					this.location,
					'\n\tParameter Info:\t\t',
					this.stringVar,
					'\n\nFull Stack Trace:\n',
					this.stack,
				);
			}

			if (this.level === LEVEL_ERROR || this.level === LEVEL_FATAL) {
				if (process.env.NODE_ENV !== 'test') {
					try {
						await apiLogMessage(this);
					} catch (error) {
						// eslint-disable-next-line no-console
						console.log('Error logging message - ', error);
					}
				}
			}
		});
	}
}

export default KioskLog;
